<template>
  <div class="components overFlowAuto">
    <div class="headingArea">
      <div class="mTitle">
        
        <div class="ec-base-box typeThin supply_main board_background mt-2">
          <button type="button" class="icon eTip mr-2 cursor-auto">도움말</button>
          <p class="board_background">
            쇼핑몰 관리자 > 쇼핑몰 설정 > 주문설정 > 주문 후 설정 > 취소/교환/반품 접수 시 할인/적립 금액 설정 값이 
            <font class="bold">할인금액 자동계산(설정한 이후 접수된 주문부터 적용)을 사용하여야 정산대상에 적용</font>가능합니다.<br/>
            <font class="bold">정산금액=판매액−수수료+배송비−할인금액 공급사부담−패널티금액-공제금액+환급금액</font><br/>
          할인 금액 정산 설정을 변경하면, 변경한 시점 이후에 발생하는 거래부터 새로운 설정이 적용됩니다. 이미 집계 중인 정산 예정 금액에는 반영되지 않습니다.
          </p>
        </div>

        <h1 class="page-title">공급사 정산 설정</h1>
      </div>
    </div>
    <Setting></Setting>
  </div>
</template>

<script>
import Setting from "@/components/setting/Setting.vue";

export default {
  name: "SettingView",
  components: {
    Setting,
  },
};
</script>
